export function NotFoundLetter() {
  return (
    <p className='w-full min-w-[500px] text-sm font-light italic text-gray-2 text-center'>
      No letter found
    </p>
  );
}
